import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useTheme } from '@mui/material';

const ToastProvider = () => {
  const theme = useTheme();

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        // Default options
        duration: 4000,
        style: {
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[4],
          padding: '16px',
          fontSize: '14px',
        },
        // Success toast style
        success: {
          iconTheme: {
            primary: theme.palette.success.main,
            secondary: theme.palette.success.contrastText,
          },
          style: {
            border: `1px solid ${theme.palette.success.light}`,
          },
        },
        // Error toast style
        error: {
          iconTheme: {
            primary: theme.palette.error.main,
            secondary: theme.palette.error.contrastText,
          },
          style: {
            border: `1px solid ${theme.palette.error.light}`,
          },
        },
        // Loading toast style
        loading: {
          iconTheme: {
            primary: theme.palette.primary.main,
            secondary: theme.palette.primary.contrastText,
          },
        },
      }}
    />
  );
};

export default ToastProvider;

// Export toast helper functions
export { toast } from 'react-hot-toast';
